import { PageDecrationSet } from './libs/pageDecrationSet';
import { TopMvSwiper, TvSwiper } from './libs/swiper';
import { TopNews } from './libs/topNews';

document.addEventListener('DOMContentLoaded', function () {
  const front = new Front();
});

class Front {
  constructor() {
    this.pageDecrationSet = new PageDecrationSet();
    this.topMvSwiper = new TopMvSwiper('.js-top-mv-swiper');
    this.topMvSwiper.start();
    this.toNews = new TopNews();
  }
}
